import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getInventoryCountList } from '../../../store/INV/InventoryCount/inventoryCountSlice';

const useGetInventoryCountList= () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (InventoryCountOpenList?.length === 0) {
      dispatch(getInventoryCountList());
    }
  }, []);
  const { InventoryCountList: InventoryCountOpenList, loading , error } = useAppSelector((state) => state.InventoryCount);

  return { InventoryCountOpenList, loading , error };
};

export default useGetInventoryCountList;
